import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import http from '../../../lib/http/index.js';

const getIndiceAt = (indices = [], fecha = new Date(), difMeses = 0) => {
    function fechaNMesesAntes(ts, N) {
        let fecha = new Date(ts);
        fecha.setMonth(fecha.getMonth() + N);
        return fecha;
    };

    if (indices == null) return 1;
    fecha = new Date(typeof fecha === 'string' ? parseInt(fecha) : fecha);
    fecha = fechaNMesesAntes(fecha.getTime(), difMeses);
    return (indices || [])
        .filter(i => {
            const iFecha = new Date(parseInt(i.fecha));
            return iFecha.getFullYear() === fecha.getFullYear() && iFecha.getMonth() === fecha.getMonth();
        }).sort((a, b) => a.fecha - b.fecha)[0];
};

export const getData = createAsyncThunk('GET_DATA_COMISIONES', async (payload, thunkAPI) => {
    let contratos = [...(await http.TABLE('/contratos')).body];
    const personas = (await http.TABLE('/personas')).body;
    const clasesContratos = (await http.TABLE('/clasesContrato')).body;
    const indices = (await http.TABLE('/indices')).body;
    const pagos = (await http.TABLE('/pagos')).body;
    const cdcContratos = (await http.TABLE('/contratos-cdc')).body;
    const tiposCampana = (await http.TABLE('/tipos-campana')).body;
    const campanas = (await http.TABLE('/campanas')).body;

    contratos = contratos.map(c => ({
        ...c,
        clasesContrato: clasesContratos.find(x => x.claseContratoId === c.claseContratoId),
        indice: getIndiceAt(indices, c.fechaCreacion, -2),
        pagos: pagos.filter(x => x.contratoId === c.contratoId)
    }));

    const vendedores = personas.reduce((p, x) => {
        const meses = ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'];
        p.push({
            ...x,
            ventas: contratos
                .filter(y => y.vendedorId === x.personaId)
                .reduce((p, x) => {
                    const date = new Date(parseInt(x.fechaPerfeccionamiento));
                    const year = date.getFullYear();
                    const month = date.getMonth();
                    const key = `${meses[month]}-${year%1000}`;
                    p[key] ??= [];
                    p[key].push(x);
                    return p;
                }, {})
        });
        return p;
    }, []).filter(x => Object.keys(x.ventas).length > 0);

    return { vendedores };
});

const initialState = {
    fetching: 0,
    error: null,
    message: null,
    data: {}
};

const comisionesSlice = createSlice({
    name: 'comisionesCat',
    initialState,
    reducers: {
        cleanError: (state, action) => ({ ...state, error: null }),
        cleanMessage: (state, action) => ({ ...state, message: null }),
    },
    extraReducers: {
        [getData.pending]: (state, action) => ({ ...state, fetching: state.fetching + 1 }),
        [getData.rejected]: (state, action) => ({ ...state, fetching: state.fetching - 1, error: action }),
        [getData.fulfilled]: (state, action) => ({ ...state, data: action.payload, fetching: state.fetching - 1 })
    },
})

export const { cleanError, cleanMessage } = comisionesSlice.actions
export default comisionesSlice.reducer;